import angular from 'angular';
import { get, includes, forEach, isEmpty } from 'lodash';
import moment from 'moment-timezone';
import 'angular-ui-tree';
import '../../services/area';
import '../../services/place';
import '../../services/errors';
import '../../components/osom';
import { AreaCalendarType } from '../../utils/areaCalendarType';
import { localStorage, schedule } from '../../utils';
import '../../components/schedule/exact-schedules';
import '../../app.constants';
import '../../directives/prevent-spaces';

const module = angular.module('whyline.modals.area', [
  'whyline.services.appointment',
  'whyline.services.area',
  'whyline.services.place',
  'whyline.services.errors',
  'whyline.components.osom',
  'whyline.services.organization',
  'whyline.components.exactSchedule',
  'whyline.constants',
  'whyline.directives.preventSpaces',
]);

const AreaModalController = (
  $scope,
  $timeout,
  $state,
  $uibModalInstance,
  $translate,
  GlobalsService,
  NotificationService,
  AreaService,
  modalType,
  areaId,
  ErrorService,
  PlaceService,
  dialog,
  OrganizationService,
  SAFE_STATES,
) => {
  'ngInject';

  const namePattern = /^[ '-:\u0621-\u064Aa-zA-Z\xC0-\xCF\xD1-\xD6\xD8-\xDD\xDF-\xE5\xE7-\xF6\xF8-\xFD\xFF\u0104-\u0107\u010C\u010D\u0116-\u0119\u012E\u012F\u0141-\u0144\u0152\u0160\u0161\u016A\u016B\u0172\u0173\u0178-\u017E]+$/;
  const urlPattern = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9]\.[^\s]{2,})/i;
  const htmlPattern = /<(br|basefont|hr|input|source|frame|param|area|meta|!--|col|link|option|base|img|wbr|!DOCTYPE).*?>|<(a|abbr|acronym|address|applet|article|aside|audio|b|bdi|bdo|big|blockquote|body|button|canvas|caption|center|cite|code|colgroup|command|datalist|dd|del|details|dfn|dialog|dir|div|dl|dt|em|embed|fieldset|figcaption|figure|font|footer|form|frameset|head|header|hgroup|h1|h2|h3|h4|h5|h6|html|i|iframe|ins|kbd|keygen|label|legend|li|map|mark|menu|meter|nav|noframes|noscript|object|ol|optgroup|output|p|pre|progress|q|rp|rt|ruby|s|samp|script|section|select|small|span|strike|strong|style|sub|summary|sup|table|tbody|td|textarea|tfoot|th|thead|time|title|tr|track|tt|u|ul|var|video).*?<\/\2>/i;
  // #region Initialize Variables
  $scope.items = [];
  $scope.dynamicLines = [];
  $scope.supervisors = [];
  $scope.exactSchedule = schedule.reOrder(schedule.createExactDaySchedule());

  $scope.enterpriseType = GlobalsService.EnterpriseType;
  const currentUser = localStorage.get('user');
  $scope.superAdmin = currentUser && currentUser.sudo;
  const currentOrganization = OrganizationService.GetCurrent();
  $scope.slotPerHourEnabled = get(
    currentOrganization,
    'configuration.agenda.slotPerTimeRange',
    false,
  );
  const defaultMinutes = 30;
  $scope.organization = OrganizationService.GetCurrent();
  $scope.area = {
    schedule: schedule.reOrder(schedule.create()),
    maxNumbers: 0,
    isWithAppointment: false,
    appointmentsFromTotem: false,
    withoutAppointment: {
      withPriority: true,
      withoutPriority: true,
      requestSource: {
        mobileApp: true,
        reception: true,
        totem: true,
      },
    },
    appointmentsConfiguration: {
      enabled: false,
      enabledForAgendaUsers: true,
      slots: 1,
      duration: 30,
      timeSlotsQuantity: 1,
      areaCalendarType: AreaCalendarType.ForADynamicPeriod,
      dynamicPeriod: {
        since: false,
        sinceNextDays: 0,
        until: true,
        untilNextDays: 90,
        enableMinutesToCreateAnAppointment: {
          minutes: 30,
          enabled: false,
        },
      },
      fixedPeriod: {
        from: null,
        to: null,
      },
      notes: {
        required: false,
        label: '',
        placeholder: '',
        visible: false,
      },
      penalty: {
        canceledAppointments: 0,
        enabled: false,
        since: 0,
        time: 0,
      },
      alertMessage: {
        text: '',
        show: false,
      },
      validateAppointmentQuantityByPerson: {
        quantity: 0,
        required: false,
      },
      supportsTelemedicine: false,
      additionalInformationLink: '',
      supportsPresential: true,
    },
    configuration: {
      showSubscriptionsBy: {
        dailySubscriptions: true,
        lastHoursSubscriptions: false,
      },
    },
  };

  $scope.showSubscriptionsConfig = {
    showSubscriptionsBy: ['dailySubscriptions', 'lastHoursSubscriptions'],
    selectedShowSubscriptionsBy: 'dailySubscriptions',
  };

  $scope.onShowSubscriptionsByChange = () => {
    const configs = Object.keys($scope.area.configuration.showSubscriptionsBy);

    if (configs.length) {
      configs.forEach((key) => {
        if (key == $scope.showSubscriptionsConfig.selectedShowSubscriptionsBy) {
          $scope.area.configuration.showSubscriptionsBy[key] = true;
        } else {
          $scope.area.configuration.showSubscriptionsBy[key] = false;
        }
      });
    }
  };

  $scope.disableVisible = (value) => {
    $scope.area.appointmentsConfiguration.notes.visible =
      value || $scope.area.appointmentsConfiguration.notes.visible;
  };

  function initSubscriptionsByChange() {
    const configs = Object.keys($scope.area.configuration.showSubscriptionsBy);
    if (configs.length) {
      configs.forEach((key) => {
        if ($scope.area.configuration.showSubscriptionsBy[key] == true) {
          $scope.showSubscriptionsConfig.selectedShowSubscriptionsBy = key;
        }
      });
    }
  }

  $scope.fromToDates = {
    from: moment().startOf('day').toDate(),
    to: moment().startOf('day').toDate(),
  };

  // Date picker
  $scope.dateOptionsFrom = {
    minDate: moment().startOf('day').toDate(),
    startingDay: 1,
  };
  $scope.dateOptionsTo = {
    minDate: moment().startOf('day').toDate(),
    startingDay: 1,
  };
  $scope.datesIsOpen = {
    from: false,
    to: false,
  };
  // End of Date picker

  if (modalType === 'group') {
    $scope.title = 'groups';
    $scope.isDraggable = false;
  } else {
    $scope.title = 'processes';
    $scope.isDraggable = true;
  }

  // #endregion

  // #region Initialize Functions
  const ignoreSlotValidationOnSaveArea = () => {
    const currentOrganization = $scope.organization;
    const ignoreSlotValidationOnSaveArea = get(
      currentOrganization,
      'configuration.agenda.ignoreSlotValidationOnSaveArea',
      false,
    );
    return ignoreSlotValidationOnSaveArea;
  };

  const updateWithAcceptSlotChange = (message) => {
    const msgs = [
      'area.cant-change-configuration-because-appointments-exists',
      'area.cant-decrease-slots-configuration-because-appointments-exists',
    ];

    if (msgs.includes(message) && ignoreSlotValidationOnSaveArea()) {
      dialog.confirm($translate.instant('accept_Slot_Change')).then(() =>
        AreaService.Update($scope.area, true)
          .then(() => {
            NotificationService.Success($translate.instant('area_update_succ'));
            $uibModalInstance.close('cancel');
          })
          .catch((err) => {
            err.context = get(err, 'data.context', {});
            ErrorService.handler(err);
          }),
      );
    }
  };

  const appointmentMinute = {
    set: (value) => {
      $scope.area.appointmentsConfiguration.dynamicPeriod.enableMinutesToCreateAnAppointment.minutes = value;
    },
    get: () =>
      $scope.area.appointmentsConfiguration.dynamicPeriod.enableMinutesToCreateAnAppointment
        .minutes,
  };

  const populateAlreadyShown = () => {
    $scope.itemsPopulated = {};
    forEach($scope.items, (line) => {
      $scope.itemsPopulated[line._id] = line;
    });
    forEach($scope.supervisors, (supervisor) => {
      $scope.itemsPopulated[supervisor._id] = supervisor;
    });
  };

  const updateTotalDuration = () => {
    $scope.totalDuration =
      $scope.area.appointmentsConfiguration.duration *
      $scope.area.appointmentsConfiguration.timeSlotsQuantity;
  };

  const updateArea = () =>
    AreaService.Update($scope.area, false)
      .then(() => {
        NotificationService.Success($translate.instant('area_update_succ'));
        $uibModalInstance.close('cancel');
      })
      .catch((err) => {
        err.context = get(err, 'data.context', {});
        const message = get(err, 'data.message', '');
        if (ignoreSlotValidationOnSaveArea()) {
          updateWithAcceptSlotChange(message);
        } else {
          ErrorService.handler(err);
        }
      });

  const updateAreaWithDialog = (penalty) => {
    const message = penalty ? 'area.penalty_time_update_sure' : 'area.penalty_time_delete_sure';
    dialog
      .confirm($translate.instant(message))
      .then(() => updateArea())
      .catch(() => {
        $scope.area.appointmentsConfiguration.penalty.enabled = $scope.oldPenaltyEnabled;
        $scope.area.appointmentsConfiguration.penalty.canceledAppointments =
          $scope.oldPenaltyCanceledAppointments;
        $scope.area.appointmentsConfiguration.penalty.since = $scope.oldPenaltySince;
        $scope.area.appointmentsConfiguration.penalty.time = $scope.oldPenaltyTime;
      });
  };

  // #region Validate Ranges
  const validateRanges = (schedule) => {
    let valid = true;
    const opened = schedule.filter((s) => s.open);
    for (let i = 0; i < opened.length; i++) {
      const day = opened[i];
      if (day.firstPeriod.opening >= day.firstPeriod.closing) {
        NotificationService.Warning(
          $translate
            .instant('opening_hours_first_period_msg_validator')
            .replace('{dayname}', $translate.instant(day.name)),
        );
        valid = false;
        break;
      }
      if (day.hasSecondPeriod) {
        if (day.secondPeriod.opening <= day.firstPeriod.closing) {
          NotificationService.Warning(
            $translate
              .instant('opening_hours_second_must_be_later_first_msg_validator')
              .replace('{dayname}', $translate.instant(day.name)),
          );
          valid = false;
          break;
        }

        if (day.secondPeriod.opening >= day.secondPeriod.closing) {
          NotificationService.Warning(
            $translate
              .instant('opening_hours_second_period_msg_validator')
              .replace('{dayname}', $translate.instant(day.name)),
          );
          valid = false;
          break;
        }
      }
    }
    return valid;
  };
  // #endregion

  // #region Validate Period Configuration
  const validatePeriodConfiguration = (areaCalendarType) => {
    const {
      since,
      sinceNextDays,
      until,
      untilNextDays,
    } = $scope.area.appointmentsConfiguration.dynamicPeriod;
    const fromMoment = moment($scope.fromToDates.from).startOf('day');
    const toMoment = moment($scope.fromToDates.to).startOf('day');

    if (areaCalendarType == AreaCalendarType.ForADynamicPeriod) {
      if (since && (sinceNextDays < 1 || sinceNextDays > 365 || !sinceNextDays)) {
        NotificationService.Warning($translate.instant('appointments_invalid_since_next_days'));
        return false;
      }
      if (until && (untilNextDays < 1 || untilNextDays > 365 || !untilNextDays)) {
        NotificationService.Warning($translate.instant('appointments_invalid_until_next_days'));
        return false;
      }
    } else if (areaCalendarType == AreaCalendarType.ForAFixedPeriod) {
      if (!$scope.fromToDates.from || !$scope.fromToDates.to) {
        NotificationService.Warning($translate.instant('appointments_date_required'));
        return false;
      }

      if (
        fromMoment.isBefore(moment().startOf('day')) ||
        toMoment.isBefore(moment().startOf('day'))
      ) {
        NotificationService.Warning($translate.instant('appointments_old_date'));
        return false;
      }

      if (fromMoment.isAfter(toMoment)) {
        NotificationService.Warning(
          $translate.instant('appointments_from_date_greater_than_to_date'),
        );
        return false;
      }
    }
    return true;
  };
  // #endregion

  // #region Validate AppointmentsConfiguration
  const validateAppointmentsConfiguration = () => {
    const {
      alertMessage,
      areaCalendarType,
      duration,
      notes,
      penalty,
      slots,
      timeSlotsQuantity,
      validateAppointmentQuantityByPerson,
    } = $scope.area.appointmentsConfiguration;

    if (!timeSlotsQuantity || timeSlotsQuantity < 1) {
      NotificationService.Warning($translate.instant('appointments_min_time_slots_quantity'));
      return false;
    }

    if (!slots || !duration) {
      NotificationService.Warning($translate.instant('mandatory_appointments_duration_slots'));
      return false;
    }

    if (slots > 10000) {
      NotificationService.Warning($translate.instant('appointments_max_slots'));
      return false;
    }

    if (!validatePeriodConfiguration(areaCalendarType)) {
      return false;
    }

    if (notes.required && (!notes.hasOwnProperty('label') || !notes.label.length)) {
      NotificationService.Warning($translate.instant('appointments_label_required'));
      return false;
    }

    if (alertMessage.show) {
      if (!alertMessage.text) {
        NotificationService.Warning($translate.instant('appointments_alert_message_required'));
        return false;
      }
      if (alertMessage.text.length > 3000) {
        NotificationService.Warning($translate.instant('appointments_alert_message_too_long'));
        return false;
      }
      if (htmlPattern.test(alertMessage.text)) {
        NotificationService.Warning($translate.instant('contains_html'));
        return false;
      }
    }

    if (validateAppointmentQuantityByPerson && validateAppointmentQuantityByPerson.required) {
      if (!validateAppointmentQuantityByPerson.quantity) {
        NotificationService.Warning(
          $translate.instant('appointment_limit_by_person_message_required'),
        );
        return false;
      }
      if (
        validateAppointmentQuantityByPerson.quantity &&
        (validateAppointmentQuantityByPerson.quantity < 1 ||
          validateAppointmentQuantityByPerson.quantity > 1000)
      ) {
        NotificationService.Warning($translate.instant('appointments_limit_by_person_value'));
        return false;
      }
    }

    if (penalty && penalty.enabled) {
      if (!penalty.canceledAppointments) {
        NotificationService.Warning(
          $translate.instant('area.canceled_appointments_admitted_message_required'),
        );
        return false;
      }
      if (
        penalty.canceledAppointments &&
        (penalty.canceledAppointments < 1 || penalty.canceledAppointments > 10)
      ) {
        NotificationService.Warning(
          $translate.instant('area.canceled_appointments_admitted_value'),
        );
        return false;
      }

      if (!penalty.since) {
        NotificationService.Warning($translate.instant('area.penalty_since_message_required'));
        return false;
      }
      if (penalty.since && (penalty.since < 1 || penalty.since > 30)) {
        NotificationService.Warning($translate.instant('area.penalty_since_value'));
        return false;
      }

      if (!penalty.time) {
        NotificationService.Warning($translate.instant('area.penalty_time_message_required'));
        return false;
      }
      if (penalty.time && (penalty.time < 1 || penalty.time > 365)) {
        NotificationService.Warning($translate.instant('area.penalty_time_value'));
        return false;
      }
    }

    return true;
  };
  // #endregion

  // #region Validate With or WithoutAppointment
  const validateRequestType = (values) => {
    if (!values.isWithAppointment && !values.isWithoutAppointment) {
      NotificationService.Warning($translate.instant('min_one_request_type'));
      return false;
    }
    return true;
  };

  const validateWithoutAppointment = (withoutAppointment) => {
    if (!withoutAppointment.withPriority && !withoutAppointment.withoutPriority) {
      NotificationService.Warning($translate.instant('min_one_priority_type'));
      return false;
    }

    if (
      !withoutAppointment.requestSource.reception &&
      !withoutAppointment.requestSource.totem &&
      !withoutAppointment.requestSource.mobileApp
    ) {
      NotificationService.Warning($translate.instant('min_one_request_type'));
      return false;
    }

    return true;
  };
  // #endregion

  // #region Validate Lines enabled
  const validateAtLeastOneLineIsEnabled = (lines) => {
    for (const line of lines) {
      if (line.enabled) {
        return true;
      }
    }
    return false;
  };

  // #endregion

  const validateAppointmentMinutes = () => {
    if (!appointmentMinute.get()) {
      NotificationService.Warning($translate.instant('max_length_MinutesToCreateAnAppointment'));
      return false;
    }
    return true;
  };

  const validate = () => {
    const name = $scope.area.label;
    const preJoin = get($scope, 'area.configuration.messages.preJoin', {
      text: '',
      button: {
        label: '',
        url: '',
      },
    });
    const preJoinButtonLabel = get(preJoin, 'button.label', '');
    const preJoinButtonUrl = get(preJoin, 'button.url', '');
    const postMessage = get($scope, 'area.configuration.postMessage', '');
    const { aliasPrefix } = $scope.area;
    const linesToValidate = $scope.area.dynamic ? $scope.dynamicLines : $scope.items;

    if (!name) {
      NotificationService.Warning($translate.instant('mandatory_area_name'));
      return false;
    }
    if (name.length > 50) {
      NotificationService.Warning($translate.instant('max_length_name'));
      return false;
    }
    if (get(preJoin, 'text') && preJoin.text.length > 300) {
      NotificationService.Warning($translate.instant('max_length_pre_join_message'));
      return false;
    }
    if (preJoinButtonLabel && preJoinButtonUrl && !get(preJoin, 'text')) {
      NotificationService.Warning($translate.instant('prejoin_empty_text'));
      return false;
    }
    if (!preJoinButtonLabel && preJoinButtonUrl) {
      NotificationService.Warning($translate.instant('button-label-mandatory'));
      return false;
    }
    if (preJoinButtonLabel && !preJoinButtonUrl) {
      NotificationService.Warning($translate.instant('button-url-mandatory'));
      return false;
    }
    if (preJoinButtonLabel && preJoinButtonUrl) {
      if (preJoinButtonLabel.length > 22) {
        NotificationService.Warning($translate.instant('button-label-max-length'));
        return false;
      }
      if (!urlPattern.test(preJoinButtonUrl)) {
        NotificationService.Warning($translate.instant('button-url-invalid'));
        return false;
      }
    }
    if (postMessage.length > 59) {
      NotificationService.Warning($translate.instant('max_length_post_check_in_message'));
      return false;
    }
    if (!namePattern.test(name)) {
      NotificationService.Warning($translate.instant('char_forbidden_name'));
      return false;
    }

    if (linesToValidate.length <= 0) {
      NotificationService.Warning($translate.instant('min_fila_assign'));
      return false;
    }

    if (!validateRanges($scope.area.schedule)) {
      return false;
    }

    const requestTypes = {
      isWithAppointment: $scope.area.isWithAppointment,
      isWithoutAppointment: $scope.area.isWithoutAppointment,
      appointmentsFromTotem: $scope.area.appointmentsFromTotem,
    };
    if (!validateRequestType(requestTypes)) {
      return false;
    }

    if (
      $scope.area.isWithoutAppointment &&
      !validateWithoutAppointment($scope.area.withoutAppointment)
    ) {
      return false;
    }

    if (!$scope.area.dynamic && !validateAtLeastOneLineIsEnabled($scope.items)) {
      NotificationService.Warning($translate.instant('at_least_one_line_enabled'));
      return false;
    }

    if ($scope.area.appointmentsConfiguration.enabled) {
      if (!validateAppointmentsConfiguration()) {
        return false;
      }
    }

    if (!validateAppointmentMinutes()) {
      return false;
    }

    if (get($scope.area.configuration, 'multipleSubscriptions.enabled.subscriptions', false)) {
      const maxPeoplePerSubscription = get(
        $scope.area.configuration,
        'multipleSubscriptions.maxPeople',
        1,
      );

      if (maxPeoplePerSubscription < 2 || maxPeoplePerSubscription > 10) {
        NotificationService.Warning($translate.instant('area.max_people_per_subscription_value'));
        return false;
      }
    }

    if (
      get($scope.place, 'configuration.aliasType') === 'prefixWithIncrementalNumberAlias' &&
      (!aliasPrefix || aliasPrefix.trim().length === 0)
    ) {
      NotificationService.Warning($translate.instant('mandatory_prefix_decorator'));
      return false;
    }

    return true;
  };

  $scope.dateChange = () => {
    $scope.dateOptionsTo.minDate = $scope.fromToDates.from;
    if ($scope.fromToDates.to < $scope.fromToDates.from) {
      $scope.fromToDates.to = $scope.fromToDates.from;
    }
  };

  // Dynamic Period
  $scope.sinceCheck = () => {
    if ($scope.area.appointmentsConfiguration.dynamicPeriod.since) {
      $scope.area.appointmentsConfiguration.dynamicPeriod.sinceNextDays = 1;
      $scope.area.appointmentsConfiguration.dynamicPeriod.enableMinutesToCreateAnAppointment.enabled = false;
      $scope.minutesCheck();
    } else {
      $scope.area.appointmentsConfiguration.dynamicPeriod.sinceNextDays = 0;
    }
  };

  $scope.untilCheck = () => {
    if ($scope.area.appointmentsConfiguration.dynamicPeriod.until) {
      $scope.area.appointmentsConfiguration.dynamicPeriod.untilNextDays = 1;
    } else {
      $scope.area.appointmentsConfiguration.dynamicPeriod.untilNextDays = 0;
    }
  };

  $scope.minutesCheck = () => {
    if (!appointmentMinute.get()) {
      appointmentMinute.set(defaultMinutes);
    }
  };
  // End of Dynamic Period

  $scope.quantityCheck = () => {
    if ($scope.area.appointmentsConfiguration.validateAppointmentQuantityByPerson.required) {
      $scope.area.appointmentsConfiguration.validateAppointmentQuantityByPerson.quantity = 1;
    } else {
      $scope.area.appointmentsConfiguration.validateAppointmentQuantityByPerson.quantity = 0;
    }
  };

  $scope.penaltyCheck = () => {
    if ($scope.area.appointmentsConfiguration.penalty.enabled) {
      $scope.area.appointmentsConfiguration.penalty.canceledAppointments = 1;
      $scope.area.appointmentsConfiguration.penalty.since = 30;
      $scope.area.appointmentsConfiguration.penalty.time = 7;
    } else {
      $scope.area.appointmentsConfiguration.penalty.canceledAppointments = 0;
      $scope.area.appointmentsConfiguration.penalty.since = 0;
      $scope.area.appointmentsConfiguration.penalty.time = 0;
    }
  };

  // OSOM line selector
  $scope.selectLine = (selection) => {
    const itemSelected = {
      label: selection.name,
      _id: selection._id,
      type: selection.type,
      realType: selection.realType,
      statistics: selection.statistics,
      waitingPeople: selection.waitingPeople,
    };
    if (
      !includes(
        $scope.items.map((item) => item._id),
        selection._id,
      )
    ) {
      $scope.items.push(itemSelected);
    }
    populateAlreadyShown();
  };

  $scope.removeLine = (lineId) => {
    $scope.items = $scope.items.filter((item) => item._id !== lineId);
    populateAlreadyShown();
  };

  // OSOM supervisor selector
  $scope.selectSupervisor = (selection) => {
    const userSelected = { label: selection.name, _id: selection._id };
    if (
      !includes(
        $scope.supervisors.map((supervisor) => supervisor._id),
        selection._id,
      )
    ) {
      $scope.supervisors.push(userSelected);
    }
    populateAlreadyShown();
  };

  $scope.removeSupervisor = (userId) => {
    $scope.supervisors = $scope.supervisors.filter((supervisor) => supervisor._id !== userId);
    populateAlreadyShown();
  };

  $scope.cancel = () => {
    $uibModalInstance.close('cancel');
  };

  $scope.validateNumber = () => {
    let number = parseInt($scope.area.maxNumbers);
    number = isNaN(number) ? 0 : number;
    $scope.area.maxNumbers = number;
  };

  $scope.save = () => {
    schedule.scheduleFormat($scope.area.schedule, $scope.exactSchedule, false);

    if (validate()) {
      $scope.area.lines = $scope.items.filter((item) => item.enabled).map((item) => item._id);
      $scope.area.dynamicLines = !isEmpty($scope.dynamicLines) ? $scope.dynamicLines : null;
      $scope.area.supervisors = $scope.supervisors.map((supervisor) => supervisor._id);

      if (!$scope.area.appointmentsConfiguration.duration) {
        Reflect.deleteProperty($scope.area.appointmentsConfiguration, 'duration');
      }

      if (!$scope.area.appointmentsConfiguration.slots) {
        Reflect.deleteProperty($scope.area.appointmentsConfiguration, 'slots');
      }

      if (!$scope.place.branchId) {
        Reflect.deleteProperty($scope.area, 'serviceId');
      }

      Reflect.deleteProperty($scope.area, 'linesDisabled');

      $scope.area.appointmentsConfiguration.fixedPeriod.from = moment(
        new Date($scope.fromToDates.from),
      ).format('YYYY-MM-DD');
      $scope.area.appointmentsConfiguration.fixedPeriod.to = moment(
        new Date($scope.fromToDates.to),
      ).format('YYYY-MM-DD');
      $scope.area.appointmentsConfiguration.dynamicPeriod.sinceNextDays = get(
        $scope.area.appointmentsConfiguration.dynamicPeriod,
        'sinceNextDays',
        0,
      );
      $scope.area.appointmentsConfiguration.dynamicPeriod.untilNextDays = get(
        $scope.area.appointmentsConfiguration.dynamicPeriod,
        'untilNextDays',
        0,
      );

      if (areaId) {
        if (
          $scope.area.appointmentsConfiguration.penalty.time !== $scope.oldPenaltyTime &&
          $scope.oldPenaltyEnabled
        ) {
          return updateAreaWithDialog($scope.area.appointmentsConfiguration.penalty.time);
        }
        return updateArea();
      }

      if (modalType === 'group') {
        $scope.area.ordered = false;
        $scope.area.realType = 'group';
      } else {
        $scope.area.ordered = true;
        $scope.area.realType = 'process';
      }

      return AreaService.Create($scope.area)
        .then(() => {
          NotificationService.Success($translate.instant('area_create_succ'));
          $uibModalInstance.close('cancel');
        })
        .catch(ErrorService.handler);
    }
  };

  $scope.telemedicineSwitchVisible = () => {
    const currentOrganization = $scope.organization;
    const supportsTelemedicine = get(
      currentOrganization,
      'configuration.agenda.supportsTelemedicine',
      false,
    );
    return supportsTelemedicine;
  };

  $scope.presentialSwitchVisible = () => {
    const currentOrganization = $scope.organization;
    const supportsTelemedicine = get(
      currentOrganization,
      'configuration.agenda.supportsTelemedicine',
      false,
    );
    const telemedicineEnabled = get(
      $scope,
      'area.appointmentsConfiguration.supportsTelemedicine',
      false,
    );
    return supportsTelemedicine && telemedicineEnabled;
  };

  $scope.additionalInformationLinkVisible = () => {
    const currentOrganization = $scope.organization;
    const supportsAdditionalInfoLinks = get(
      currentOrganization,
      'configuration.agenda.supportsAdditionalInfoLinks',
      false,
    );
    return supportsAdditionalInfoLinks;
  };

  $scope.doesItAllowMultipleSubscriptions = () =>
    get($scope.place, 'configuration.allowMultipleSubscriptions', false);

  $scope.goToSlotsAdvancedConfig = () => {
    $uibModalInstance.close('cancel');
    $state.go(SAFE_STATES.slotsPerTimeRange, { areaId: $scope.area._id });
  };

  $scope.cancelEdit = () => {
    schedule.scheduleFormat($scope.area.schedule, $scope.exactSchedule);
    $scope.editStatus.openEditingDayList = false;
  };

  $scope.applySchedule = () => {
    schedule.scheduleFormat($scope.area.schedule, $scope.exactSchedule, false);
    if (validateRanges($scope.area.schedule)) {
      $scope.editStatus.openEditingDayList = false;
    }
  };

  $scope.editSchedule = () => {
    schedule.scheduleFormat($scope.area.schedule, $scope.exactSchedule);
    $scope.editStatus.openEditingDayList = true;
  };

  // #endregion

  // #region Init
  const init = () => {
    $scope.$watch('area.appointmentsConfiguration.timeSlotsQuantity', updateTotalDuration);
    $scope.$watch('area.appointmentsConfiguration.duration', updateTotalDuration);

    PlaceService.GetOneAsPromise($state.params.placeId).then((place) => {
      $timeout(() => {
        $scope.place = place;
      });
    });
    $scope.editStatus = {
      openEditingDayList: false,
    };
    // #region Update Area
    if (areaId) {
      AreaService.GetCurrentWithLines(areaId)
        .then((res) => {
          $timeout(() => {
            $scope.area = AreaService.Copy(res);
            schedule.scheduleFormat($scope.area.schedule, $scope.exactSchedule);
            const fromDate = get(
              $scope.area,
              'appointmentsConfiguration.fixedPeriod.from',
              undefined,
            );
            const toDate = get($scope.area, 'appointmentsConfiguration.fixedPeriod.to', undefined);
            const sinceDays = get(
              $scope.area,
              'appointmentsConfiguration.dynamicPeriod.sinceNextDays',
              0,
            );
            const untilDays = get(
              $scope.area,
              'appointmentsConfiguration.dynamicPeriod.untilNextDays',
              90,
            );
            const calendarType = get(
              $scope.area,
              'appointmentsConfiguration.areaCalendarType',
              'forADynamicPeriod',
            );
            const enableMinutesToCreateAnAppointment = get(
              $scope.area,
              'appointmentsConfiguration.dynamicPeriod.enableMinutesToCreateAnAppointment',
              {},
            );
            $scope.area.appointmentsConfiguration.validateAppointmentQuantityByPerson.required = get(
              $scope.area,
              'appointmentsConfiguration.validateAppointmentQuantityByPerson.required',
              false,
            );
            $scope.area.appointmentsConfiguration.validateAppointmentQuantityByPerson.quantity = get(
              $scope.area,
              'appointmentsConfiguration.validateAppointmentQuantityByPerson.quantity',
              0,
            );

            $scope.area.appointmentsConfiguration.penalty.enabled = get(
              $scope.area,
              'appointmentsConfiguration.penalty.enabled',
              false,
            );
            $scope.area.appointmentsConfiguration.penalty.canceledAppointments = get(
              $scope.area,
              'appointmentsConfiguration.penalty.canceledAppointments',
              0,
            );
            $scope.area.appointmentsConfiguration.penalty.since = get(
              $scope.area,
              'appointmentsConfiguration.penalty.since',
              0,
            );
            $scope.area.appointmentsConfiguration.penalty.time = get(
              $scope.area,
              'appointmentsConfiguration.penalty.time',
              0,
            );
            $scope.oldPenaltyEnabled = get(
              $scope.area,
              'appointmentsConfiguration.penalty.enabled',
              false,
            );
            $scope.oldPenaltyCanceledAppointments = get(
              $scope.area,
              'appointmentsConfiguration.penalty.canceledAppointments',
              0,
            );
            $scope.oldPenaltySince = get($scope.area, 'appointmentsConfiguration.penalty.since', 0);
            $scope.oldPenaltyTime = get($scope.area, 'appointmentsConfiguration.penalty.time', 0);

            $scope.fromToDates.from = moment(fromDate).startOf('day').toDate();
            $scope.fromToDates.to = moment(toDate).startOf('day').toDate();
            $scope.area.appointmentsConfiguration.dynamicPeriod.sinceNextDays = sinceDays;
            $scope.area.appointmentsConfiguration.dynamicPeriod.untilNextDays = untilDays;
            $scope.area.appointmentsConfiguration.dynamicPeriod.enableMinutesToCreateAnAppointment.minutes = get(
              enableMinutesToCreateAnAppointment,
              'minutes',
              30,
            );
            $scope.area.appointmentsConfiguration.dynamicPeriod.enableMinutesToCreateAnAppointment.enabled = get(
              enableMinutesToCreateAnAppointment,
              'enabled',
              false,
            );
            $scope.area.appointmentsConfiguration.dynamicPeriod.since = get(
              $scope.area,
              'appointmentsConfiguration.dynamicPeriod.since',
              false,
            );
            $scope.area.appointmentsConfiguration.dynamicPeriod.until = get(
              $scope.area,
              'appointmentsConfiguration.dynamicPeriod.until',
              true,
            );
            $scope.area.appointmentsConfiguration.areaCalendarType =
              calendarType !== 'forADynamicPeriod' && calendarType !== 'forAFixedPeriod'
                ? 'forADynamicPeriod'
                : calendarType;
            $scope.area.appointmentsFromTotem = get($scope.area, 'appointmentsFromTotem', false);
            $scope.linesPopulated = res.linesPopulated;
            $scope.supervisorsPopulated = res.supervisorsPopulated;
            if (res.dynamic) {
              const linesPopulated = Object.values(res.linesPopulated);
              res.dynamicLines.forEach((item) => {
                const lineFound = linesPopulated.find((lp) => lp._id === item.lineId);
                if (lineFound && item.label !== lineFound.label) {
                  item.label = lineFound.label;
                }
              });
              $scope.dynamicLines = res.dynamicLines;
            }

            // Lleno los items de Lineas
            for (const key in res.linesPopulated) {
              const item = {
                label: res.linesPopulated[key].label,
                _id: key,
                type: res.linesPopulated[key].type,
                realType: res.linesPopulated[key].realType,
                statistics: res.linesPopulated[key].statistics,
                waitingPeople: res.linesPopulated[key].waitingPeople,
                enabled: true,
              };
              $scope.items.push(item);
            }

            for (const key in res.linesDisabledPopulated) {
              const item = {
                label: res.linesDisabledPopulated[key].label,
                _id: key,
                type: res.linesDisabledPopulated[key].type,
                realType: res.linesDisabledPopulated[key].realType,
                statistics: res.linesDisabledPopulated[key].statistics,
                waitingPeople: res.linesDisabledPopulated[key].waitingPeople,
                enabled: false,
              };
              $scope.items.push(item);
            }

            // Lleno los items de Supervisores
            for (const user in res.supervisorsPopulated) {
              const supervisor = {
                label: res.supervisorsPopulated[user].local.email,
                _id: user,
              };
              $scope.supervisors.push(supervisor);
            }
            populateAlreadyShown();
            initSubscriptionsByChange();
          });
        })
        .catch(ErrorService.handler);
    }
    // #endregion
  };
  // #endregion

  init();
};

module.exports = module.controller('AreaModalController', AreaModalController);
